/**
 * Default stroke colors per icon category. Used to color arrows that do not
 * carry a custom `color` override.
 */
import type { IconCategory, MapArrowDTO } from '@warplan/shared';

export const CATEGORY_STROKE: Record<IconCategory, string> = {
  combat: '#ef4444', // red-500
  build: '#9ca3af', // gray-400
  facility: '#a855f7', // purple-500
  logistic: '#eab308', // yellow-500
  navy: '#22d3ee', // cyan-400
  // --- Operation categories ---
  op_info:    '#60a5fa', // blue-400    — information / neutre
  op_attack:  '#ef4444', // red-500     — attaque (rouge vif, distinct des routes orange-rouge de la map)
  op_defend:  '#4ade80', // green-400   — défense (vert, fortification)
  op_arty:    '#f97316', // orange-500  — artillerie / feu (orange, distinct du rouge attaque)
  op_build:   '#facc15', // yellow-400  — construction (jaune pur, plus vif que l'ambre des routes)
  op_navy:    '#22d3ee', // cyan-400    — naval (cyan, eau)
  op_unit:    '#e879f9', // fuchsia-400 — unités (magenta, absent de tout fond de map)
  op_vehicle: '#a78bfa', // violet-400  — véhicules / blindés (violet, absent de tout fond de map)
};

export function getCategoryStroke(kind: IconCategory): string {
  return CATEGORY_STROKE[kind];
}

/** Resolves the effective rendering color of an arrow (override or category default). */
export function getArrowColor(arrow: Pick<MapArrowDTO, 'kind' | 'color'>): string {
  return arrow.color ?? CATEGORY_STROKE[arrow.kind];
}
